export default "__VITE_ASSET__fGahe4Fm__"